import endTimePickerComponentUrl from './endTimePickerComponent.html';

export default {
  bindings: {
    shift: '=',
    pickerForm: '=',
    endTime: '=',
    endHourOptions: '=',
    dropdownClass: '@?',
  },
  controllerAs: 'ctrl',
  templateUrl: endTimePickerComponentUrl,
};
